// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { string } from 'prop-types'

const FormatOverallHeader = ({ unitType }) => (
  <div className={'display-flex flex-direction-row flex-wrap-nowrap'}>
    <span>{`Overall Height (${unitType === 'SI' ? 'm' : 'ft'})`}</span>
    <span
      className={'fa fa-question-circle margin-left-half line-height-inherit'}
      id={`asr-lookup-overall-header-question-circle`}
      title={'Height above ground level'} />
  </div>
)

FormatOverallHeader.propTypes = {
  unitType: string.isRequired,
}

export default FormatOverallHeader
